import { render, staticRenderFns } from "./BalanceLevelDetailTab.vue?vue&type=template&id=a96792ba&scoped=true"
import script from "./BalanceLevelDetailTab.vue?vue&type=script&lang=js"
export * from "./BalanceLevelDetailTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceLevelDetailTab.vue?vue&type=style&index=0&id=a96792ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96792ba",
  null
  
)

export default component.exports